<template>
  <a-card :bordered="false">
    <custom-page-table
      ref="tableList"
      :columns="columns"
      base-key="orderUrl"
      params-path="order/wisdom/query/List">
        <span slot="wisdomOrderStatus" slot-scope="rowItem">
          {{ rowItem.record.wisdomOrderStatus == 0 ? '待支付' : rowItem.record.wisdomOrderStatus == 1 ? '创建失败' : rowItem.record.wisdomOrderStatus == 2 ? '出票失败' : '已出票' }}
        </span>
    </custom-page-table>
  </a-card>
</template>

<script>
export default {
  name: 'OrderConnection',
  data() {
    return {
      columns: [
        {
          title: '景区ID号',
          dataIndex: 'wisdomOrderId'
        },
        {
          title: '商品名称',
          dataIndex: 'wisdomOrderProName'
        },
        {
          title: '下单用户',
          dataIndex: 'wisdomOrderMemberName'
        },
        {
          title: '订单状态',
          dataIndex: 'wisdomOrderStatus',
          scopedSlots: { customRender: 'wisdomOrderStatus' }
        },
        {
          title: '下单时间',
          dataIndex: 'wisdomOrderCreateTime'
        }
      ]
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'YzhConnection', title: '商品绑定' },
      { name: 'OrderConnection', title: '订单直连' },
      { name: 'AddAccount', title: '关联账号' }
    ])
  },
  methods: {}
}
</script>
<style scoped></style>
